export { default } from './client-module-loader';
